import React, { useState } from "react";
import {Link} from 'gatsby'

import Logo from "../../assets/images/cimplify-white-logo.svg"


import InstagramImg1 from "../../assets/images/team/team-img1.jpg"
import InstagramImg2 from "../../assets/images/team/team-img2.jpg"
import InstagramImg3 from "../../assets/images/team/team-img3.jpg"
import InstagramImg4 from "../../assets/images/team/team-img4.jpg"
import InstagramImg5 from "../../assets/images/team/team-img5.jpg"
import InstagramImg6 from "../../assets/images/team/team-img6.jpg"

const NavbarStyleTwo = () => {
    const [menu, setMenu] = React.useState(true)
 
    const toggleNavbar = () => {
        setMenu(!menu)
    }

    React.useEffect(() => {
        let elementId = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId.classList.add("is-sticky");
            } else {
                elementId.classList.remove("is-sticky");
            }
        });
        window.scrollTo(0, 0); 
    })

    // Search Modal
    const [isActiveSearchModal, setActiveSearchModal] = useState("false");
    const handleToggleSearchModal = () => {
        setActiveSearchModal(!isActiveSearchModal);
    };

    // Sidebar Modal
    const [isActiveSidebarModal, setActiveSidebarModal] = useState("false");
    const handleToggleSidebarModal = () => {
        setActiveSidebarModal(!isActiveSidebarModal);
    };
 
    const classOne = menu ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = menu ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    return (
        <React.Fragment>
            <div id="navbar" className="navbar-area navbar-color-white">
                <div className="main-nav">
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <Link to="/" onClick={toggleNavbar} className="navbar-brand">
                                <img src={Logo} alt="logo" />
                            </Link>

                            <button 
                                onClick={toggleNavbar} 
                                className={classTwo}
                                type="button" 
                                data-toggle="collapse" 
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
                                aria-expanded="false" 
                                aria-label="Toggle navigation"
                            >
                                <span className="icon-bar top-bar"></span>
                                <span className="icon-bar middle-bar"></span>
                                <span className="icon-bar bottom-bar"></span>
                            </button>

                            <div className={classOne} id="navbarSupportedContent">
                                <ul className="navbar-nav">
                                
                                     
                                        
                                        <li className="nav-item">
                                        <Link to="/" onClick={e => e.preventDefault()} className="nav-link">
                                            Solutions <i className='bx bx-chevron-down'></i>
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link to="/marketing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Marketing AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/marketing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Content Creation with AI
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/marketing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Whatsapp Marketing
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/marketing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Account Based Marketing
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/marketing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Marketing Automation
                                                        </Link>
                                                    </li>

                                                 </ul>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/manufacturing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Manufacturing AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/manufacturing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Product Inspection
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/manufacturing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Safety & Compliance
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/manufacturing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Demand Forecasting
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/manufacturing-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Accounting Automation
                                                        </Link>
                                                    </li>

                                                 </ul>
                                            </li>

                                            <li className="nav-item">
                                                <Link to="/retail-and-ecommerce-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Retail & eCommerce AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/retail-and-ecommerce-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        In-Store Traffic Analytics
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/retail-and-ecommerce-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        AI-Powered Conversations 
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/retail-and-ecommerce-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Assisted Shopping 
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/retail-and-ecommerce-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Immersive Experiences
                                                        </Link>
                                                    </li>

                                                 </ul>
                                            </li>

                                            <li className="nav-item">
                                                <Link to="/sports-and-fitness-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Sports & Fitness AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/sports-and-fitness-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        AI-Powered Biomechanics
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/sports-and-fitness-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Performance Analysis 
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/sports-and-fitness-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Digital Physiotherapy
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/sports-and-fitness-ai" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        AI-Powered Yoga
                                                        </Link>
                                                    </li>

                                                 </ul>
                                            </li>
                                        </ul>
                                     </li>
                                     <li className="nav-item">
                                        <Link to="/#" onClick={e => e.preventDefault()} className="nav-link">
                                            Services <i className='bx bx-chevron-down'></i>
                                        </Link>
    
                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                            <Link to="/vision-artifical-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Vision AI <i className='bx bx-chevron-right'></i>
                                                </Link>
                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/vision-artifical-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Holistic Human Detection
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/vision-artifical-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Object & Text Detection 
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/vision-artifical-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Text Detection & Analysis
                                                        </Link>
                                                    </li>

                                                   
                                                 </ul>
                                            </li> 

                                            <li className="nav-item">
                                                <Link to="/ai-in-conversations" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Conversational AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/ai-in-conversations" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Chatbots and Virtual Assistants
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/ai-in-conversations" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Omnichannel & Multilingual
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/ai-in-conversations" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Human-in-the-Loop
                                                        </Link>
                                                    </li>



                                                 </ul>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/natural-language-nlp-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Natural Language AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/natural-language-nlp-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Diagnostic NLP
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/natural-language-nlp-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Descriptive NLP
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/natural-language-nlp-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Predictive NLP
                                                        </Link>
                                                    </li>



                                                 </ul>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/predictive-artificial-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    Predictive AI <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/predictive-artificial-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Demand Forecasting
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/predictive-artificial-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Personalization & Recommendations
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/predictive-artificial-intelligence-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Anomaly Detection
                                                        </Link>
                                                    </li>



                                                 </ul>
                                            </li>


                                            {/* <li className="nav-item">
                                                <Link to="/ar-vr-experience-design-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    AR/VR Experience Design <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/ar-vr-experience-design-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Augmented Reality
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/ar-vr-experience-design-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Virtual Reality
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link to="/ar-vr-experience-design-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Mixed Reality
                                                        </Link>
                                                    </li>



                                                 </ul>
                                            </li> */}
                                            <li className="nav-item">
                                                <Link to="/ai-ml-app-development-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                    AI/ML App Development <i className='bx bx-chevron-right'></i>
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link to="/ai-ml-app-development-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        End-to-end Approach
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link to="/ai-ml-app-development-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Human Centered Design
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link to="/ai-ml-app-development-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Native & Progressive Web Apps
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link to="/ai-ml-app-development-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Cloud & Edge Deployment
                                                        </Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link to="/ai-ml-app-development-services" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        AI/ML Models
                                                        </Link>
                                                    </li>


                                                 </ul>
                                            </li>
                                           
                                        </ul>
                                    </li>
                                     <li className="nav-item">
                                        <Link to="/about-us" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                            About 
                                        </Link>

                                    
                                    </li>     

                                   
                                  
                                    <li className="nav-item">
                                        <Link to="/contact" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                            Contact
                                        </Link>
                                    </li>
                                                                 </ul>
                            </div>
                                
                           
                        </nav>
                    </div>
                </div>
            </div>
 
           
           
        </React.Fragment>
    );
}

export default NavbarStyleTwo;